import { useCallback, useMemo } from 'react';
import { useUser } from '../context/UserContext';
import { RightLevel, RightsMap, Rule, controlState, rightLevel, ControlState } from './levels';
import { pageRule } from './pageRights';

const NO_RIGHTS: RightsMap = {};

export interface RightsApi {
  // Vrai seulement quand les droits ont été chargés : aucun refus ne doit s'afficher avant
  ready: boolean;
  // /me en erreur : les droits sont inconnus (ce n'est PAS un refus), on propose de réessayer
  failed: boolean;
  retry: () => void;
  // Table brute, pour les règles qui dépendent aussi d'un contexte (workspace, paramètres PowerBI)
  rights: RightsMap;
  level: (key: string) => RightLevel;
  state: (key: string) => ControlState;
  can: (rule: Rule) => boolean;
  canOpen: (pathname: string) => boolean;
}

export const useRights = (): RightsApi => {
  const { userInfos, isUserLoaded, hasErrorUserInfos, refetchUserInfo } = useUser();
  const rights = (userInfos?.allRights as RightsMap | undefined) ?? NO_RIGHTS;

  const level = useCallback((key: string) => rightLevel(rights, key), [rights]);
  const can = useCallback((rule: Rule) => rule(rights), [rights]);

  return useMemo(() => ({
    ready: isUserLoaded,
    failed: hasErrorUserInfos,
    retry: refetchUserInfo,
    rights,
    level,
    state: (key: string) => controlState(level(key)),
    can,
    canOpen: (pathname: string) => pageRule(pathname)(rights),
  }), [isUserLoaded, hasErrorUserInfos, refetchUserInfo, level, can, rights]);
};
